exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RoomsAndStudents .rooms .qbm-accordion-content__item{display:flex;justify-content:space-between}.RoomsAndStudents .rooms .qbm-accordion-content__item .marker-published{width:10px;height:10px;border-radius:10px;background:#52c41a}.RoomsAndStudents .rooms .qbm-accordion-content__item .marker-unpublished{width:10px;height:10px;border-radius:10px;background:#fa541c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/RoomsAndStudents/style.scss
// module id = 4992
// module chunks = 0